import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Account ");

import { TO_INVENTORY, USER_REQUEST } from '@fm-tools/core/store';
import { getUtils, getStoreUtils } from '@fm-tools/core/composables';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const {
      account,
      logout
    } = getUtils();
    const {
      setCharacter,
      setEditCharacter,
      activeCharacter,
      characters
    } = getStoreUtils();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const jumpToInventory = () => {
      store.dispatch(USER_REQUEST).then(() => {
        const char = characters.value.find(character => character._id === activeCharacter.value._id) || null;
        setCharacter(char);
        setEditCharacter();
        if ((route.name || '').toString() !== 'My Characters') router.push({
          name: 'My Characters',
          params: {
            _tab: 'tab-Inventory'
          }
        });else store.commit(TO_INVENTORY, 'tab-Inventory');
      });
    };

    return (_ctx, _cache) => {
                                                            

                                                          

                                                                                  

                                                                      

                                                            

                                                            

      return _openBlock(), _createBlock(_component_v_menu, {
        "offset-y": "",
        left: "",
        "open-on-hover": "",
        transition: "slide-y-transition"
      }, {
        activator: _withCtx(({
          on,
          attrs
        }) => [_createVNode(_component_v_btn, _mergeProps(attrs, {
          text: ""
        }, _toHandlers(on)), {
          default: _withCtx(() => [_createVNode(_component_v_icon, {
            left: "",
            icon: "mdi-account-circle"
          }), _hoisted_1]),
          _: 2
        }, 1040)]),
        default: _withCtx(() => [_createVNode(_component_v_list, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(account), (item, index) => {
            return _openBlock(), _createBlock(_component_v_list_item, {
              key: index,
              to: item.link,
              onClick: $event => item.name === 'Sign Out' ? _unref(logout)() : item.name === 'Inventory' ? jumpToInventory() : ''
            }, {
              default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [_createVNode(_component_v_icon, {
                  left: "",
                  icon: item.icon
                }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(item.name), 1)]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1032, ["to", "onClick"]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      });
    };
  }

});

/* Vuetify */
import { VBtn as _component_v_btn } from "vuetify/lib/components/VBtn/index.mjs"
import { VIcon as _component_v_icon } from "vuetify/lib/components/VIcon/index.mjs"
import { VListItemTitle as _component_v_list_item_title, VListItem as _component_v_list_item, VList as _component_v_list } from "vuetify/lib/components/VList/index.mjs"
import { VMenu as _component_v_menu } from "vuetify/lib/components/VMenu/index.mjs"

